import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const DashedAddContainer = styled(Box)`
  border: 2px dashed rgba(29, 75, 122, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 33px;
  width: 100%;
`;
